// extracted by mini-css-extract-plugin
export default {"form":"Settings_form__5paCz","input":"Settings_input__up0PY","tooltip":"Settings_tooltip__SxGvN"};